/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

export { IdentityService } from './services/identity.service';
export { GrantService } from './services/grant.service';
export { UserRoleService } from './services/user-role.service';
export { StatusWorkflowService } from './services/status-workflow.service';
export { IntegrationEventsService } from './services/integration-events.service';
export { RegistryService } from './services/registry.service';
export { CountryService } from './services/country.service';
export { RegistryOfficesService } from './services/registry-offices.service';
export { ProductCategoryService } from './services/product-category.service';
export { ProductService } from './services/product.service';
export { VatService } from './services/vat.service';
export { AddressBookService } from './services/address-book.service';
export { MediaService } from './services/media.service';
export { OrderService } from './services/order.service';
export { WarehouseService } from './services/warehouse.service';
export { DdtService } from './services/ddt.service';
export { CommonService } from './services/common.service';
export { AgreementsService } from './services/agreements.service';
export { ServicesService } from './services/services.service';
export { GeoService } from './services/geo.service';
export { GlsShipmentsService } from './services/gls-shipments.service';
export { BrtShipmentsService } from './services/brt-shipments.service';
export { SchedulazioniService } from './services/schedulazioni.service';
export { TicketService } from './services/ticket.service';
export { TicketStatusService } from './services/ticket-status.service';
export { ApiService } from './services/api.service';
export { DeliveryService } from './services/delivery.service';
export { AssetManagementService } from './services/asset-management.service';
export { SlaService } from './services/sla.service';
export { AllegatiService } from './services/allegati.service';
export { NxLicenseService } from './services/nx-license.service';
